import { render, staticRenderFns } from "./CourseTransferIndex.vue?vue&type=template&id=f00cbfb6"
import script from "./CourseTransferIndex.vue?vue&type=script&lang=js"
export * from "./CourseTransferIndex.vue?vue&type=script&lang=js"
import style0 from "./CourseTransferIndex.vue?vue&type=style&index=0&id=f00cbfb6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports